import React from 'react'
import styled from '@emotion/styled'
import { Typography } from 'src/components/atoms/Typography'
import { BreakPoint, Styles } from 'src/components/shared/CssValues'
import PardotForm from 'src/components/pardot/PardotForm'




export const PartnerInfo = () => {
    return (
        <Container>
            <ContentsWrapper>
                <PardotForm src="https://go.commmune.jp/l/915341/2022-10-03/lbb6d" height="1000" />
            </ContentsWrapper>
            <Rights as="p">©️Commmune Inc. All rights reserved</Rights>
        </Container>
    )
    }

const Container = styled.div`
    width: 100%;
    text-align: center;
`

const ContentsWrapper = styled.div`
    max-width: 640px;
    height: auto;
    padding: 0 20px;
    margin: auto;
    @media screen and (min-width: ${BreakPoint.MOBILE}) {
        padding: 0 30px;
    }
    @media screen and (min-width: ${BreakPoint.TABLET}) {
        padding: 0 150px;
    }
    @media screen and (min-width: ${BreakPoint.LAPTOP}) {
        padding: 0 200px;
    }
`

    
const Rights = styled(Typography)`
    font-family: inherit;
    font-size: 9px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 3.11;
    letter-spacing: 0.72px;
    text-align: center;
    color: #444444;
    padding: 20px;
`

